import AnalyticsService from './service';

export const analytics = new AnalyticsService();

// Export types for external use
export type { UserProperties, ExceptionParams } from './service';
export type { BaseEventParams } from './types';

// Export hooks
export { useAnalytics } from './hooks/use-analytics';
export { usePageView } from './hooks/use-page-view';
export { useGoogleLoginTracker } from './hooks/use-google-login-tracker';
